import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Help(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0zm0 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-.123 14.083a1.126 1.126 0 11.002 2.252 1.126 1.126 0 01-.002-2.252zm.956-9.83c1.197.27 2.112 1.044 2.511 2.127.404 1.096.21 2.332-.522 3.307-.306.407-.718.763-1.117 1.108-.21.18-.415.356-.577.524-.188.196-.25.454-.25 1.02a1 1 0 11-2 0c0-.773.095-1.664.81-2.406a11 11 0 01.71-.651c.318-.276.647-.56.824-.797.322-.428.414-.957.246-1.414-.162-.44-.543-.747-1.072-.866-.745-.17-1.757.238-1.986 1.03a1 1 0 11-1.922-.554c.5-1.732 2.486-2.846 4.345-2.427z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoHelp = React.memo(Help);
export default MemoHelp;